export default __webpack_public_path__ + "static/media/Swisslog.0139dce0.png";